<template>
    <div class="how-container">
        <div class="inner-page-title">{{ $i18n.t('notifications-title') }}</div>
        <div class="container container-margin" v-if="notifications.length > 0">
            <a href="/my-account/settings" class="settings">{{ $i18n.t('settings-title') }}</a>
            <div v-for="(item, index) in notifications" :key="index" style="position: relative;">
                <div v-if="item.type === 8">
                    <div class="del-notification" @click="delNotification(item.id)">&times;</div>
                    <div class="list-item survey" v-on:click="notificationSurveyAction">
                        <img class="notification-image" :src="colorImage(item.type)"/>
                        <div class="notification-title">New survey</div>
                        <div class="notification-text">{{ $i18n.t(`survey-notification-text`) }}</div>
                        <div class="notification-date">{{ formatDate(item.createdOn) }}</div>
                    </div>
                </div>
                <div v-else>
                    <div class="del-notification" @click="delNotification(item.id)">&times;</div>
                    <div class="list-item" v-on:click="notificationAction(item)">
                        <img class="notification-image" :src="colorImage(item.type)"/>
                        <div class="notification-title">{{ notificationTitle(item) }}</div>
                        <div class="notification-text" v-if="item.type !== 3">{{ item.displayWineName }}</div>
                        <div class="notification-text" v-if="item.type === 3">{{ item.displayWineName }} at <span class="text-bold">€{{ item.price.toFixed(2) }}</span></div>
                        <div class="notification-text" v-if="item.type === 1 || item.type === 2 || item.type === 4">
                            <span class="text-bold">€{{ item.price.toFixed(2) }}</span> for {{ item.caseSize }}
                        </div>
                        <div class="notification-text" v-if="item.type === 6">{{ item.caseQuantity }} {{ item.caseQuantity > 1 ? $t('cases').toLowerCase() : $t('case').toLowerCase() }} of {{ item.caseSize }}l at <span class="text-bold">€{{ item.price.toFixed(2) }}</span></div>
                        <div class="notification-date">{{ formatDate(item.createdOn) }}</div>
                    </div>
                </div>
            </div>
            <v-dialog v-model="surveyModal" max-width="550px">
                <v-card class="survey-modal">
                    <div class="close-modal" v-on:click="closeSurveyModal">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M11.6897 0.344433C12.1007 0.738147 12.1007 1.39508 11.6897 1.7888L7.29269 6.00022L11.6897 10.2116C12.1007 10.6053 12.1007 11.2623 11.6897 11.656L11.6201 11.7226C11.2337 12.0927 10.6243 12.0931 10.2375 11.7234L5.99898 7.67256L1.76047 11.7234C1.37362 12.0931 0.764287 12.0927 0.377845 11.7226L0.308296 11.656C-0.102765 11.2623 -0.102766 10.6053 0.308296 10.2116L4.70528 6.0002L0.308318 1.7888C-0.102744 1.39508 -0.102743 0.738147 0.308318 0.344433L0.377867 0.277819C0.764309 -0.0923146 1.37364 -0.0926466 1.76049 0.277066L5.999 4.32786L10.2375 0.277066C10.6244 -0.0926465 11.2337 -0.0923141 11.6201 0.277819L11.6897 0.344433Z"
                                  fill="black" fill-opacity="0.64"/>
                        </svg>
                    </div>

                    <div v-for="(slide, index) in surveySlides" class="survey-modal__body" v-if="surveyModalStep === index">
                        <img src="../assets/survey-intro.svg" v-if="surveyModalStep === 0">
                        <img src="../assets/survey-final.svg" v-if="surveyModalStep === 5">
                        <v-card-title v-if="slide.title">{{ slide.title }}</v-card-title>
                        <v-card-text v-if="slide.description">{{ slide.description }}</v-card-text>
                        <div v-if="slide.answers">
                            <label v-for="(answer, i) in slide.answers" :for="answer.id">
                                <input type="radio" :id="answer.id" :value="answer.id" v-model="slide.status">
                                {{ answer.text }}
                            </label>
                        </div>
                        <v-card-actions v-if="surveyModalStep === 0">
                            <v-btn class="btn-primary btn-survey-proceed" text v-on:click="surveyNextStep">{{ $i18n.t(`survey-modal-start-survey`) }}</v-btn>
                        </v-card-actions>
                        <v-card-actions v-else-if="surveyModalStep >= 1 && surveyModalStep < 5" class="space-between">
                            <v-btn class="btn-primary btn-survey-outline" text v-on:click="surveyPrevStep">{{ $i18n.t(`survey-modal-back-btn`) }}</v-btn>
                            <v-btn class="btn-primary btn-survey-proceed" text v-on:click="surveyNextStep" :disabled="slide.status === 0">{{ $i18n.t(`survey-modal-continue-btn`) }}</v-btn>
                        </v-card-actions>
                        <v-card-actions v-else>
                            <v-btn class="btn-primary btn-survey-proceed" text v-on:click="closeSurveyModal">{{ $i18n.t(`survey-modal-submit-btn`) }}</v-btn>
                        </v-card-actions>
                    </div>

                </v-card>
            </v-dialog>
        </div>
        <div class="container" v-else>
            <div class="no-text">You don't have any notifications</div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import {GUser} from '@/store/getters';
import {AOrders, AUser, AWines} from "@/store/actions";
import {mapGetters} from "vuex";

export default {
    name: "How",
    head: {
        title: 'Notifications | Fine Wine Trading App',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
            }
        ],
        bodyAttrs: {
            class: 'trading-desk inner-page'
        }
    },
    data() {
        return {
            surveyModal: false,
            surveyModalStep: 0,
            surveySlides: [
                {
                    icon: 'survey-intro.svg',
                    title: this.$i18n.t(`survey-modal-welcome-title`),
                    description: this.$i18n.t(`survey-modal-welcome-description`)
                },
                {
                    status: 0,
                    title: this.$i18n.t(`survey-q1-title`),
                    answers: [
                        {id: 13, text: this.$i18n.t(`survey-q1-a1`)},
                        {id: 14, text: this.$i18n.t(`survey-q1-a2`)},
                        {id: 15, text: this.$i18n.t(`survey-q1-a3`)},
                        {id: 16, text: this.$i18n.t(`survey-q1-a4`)}
                    ]
                },
                {
                    status: 0,
                    title: this.$i18n.t(`survey-q2-title`),
                    answers: [
                        {id: 17, text: this.$i18n.t(`survey-q2-a1`)},
                        {id: 18, text: this.$i18n.t(`survey-q2-a2`)},
                        {id: 19, text: this.$i18n.t(`survey-q2-a3`)},
                        {id: 20, text: this.$i18n.t(`survey-q2-a4`)},
                        {id: 21, text: this.$i18n.t(`survey-q2-a5`)}
                    ]
                },
                {
                    status: 0,
                    title: this.$i18n.t(`survey-q3-title`),
                    answers: [
                        {id: 22, text: this.$i18n.t(`survey-q3-a1`)},
                        {id: 23, text: this.$i18n.t(`survey-q3-a2`)},
                        {id: 24, text: this.$i18n.t(`survey-q3-a3`)},
                        {id: 25, text: this.$i18n.t(`survey-q3-a4`)},
                        {id: 26, text: this.$i18n.t(`survey-q3-a5`)}
                    ]
                },
                {
                    status: 0,
                    title: this.$i18n.t(`survey-q4-title`),
                    answers: [
                        {id: 27, text: this.$i18n.t(`survey-q4-a1`)},
                        {id: 28, text: this.$i18n.t(`survey-q4-a2`)},
                        {id: 29, text: this.$i18n.t(`survey-q4-a3`)},
                        {id: 30, text: this.$i18n.t(`survey-q4-a4`)},
                        {id: 31, text: this.$i18n.t(`survey-q4-a5`)},
                        {id: 32, text: this.$i18n.t(`survey-q4-a6`)}
                    ]
                },
                {
                    icon: '',
                    title: this.$i18n.t(`survey-modal-last-step-title`),
                    description: this.$i18n.t(`survey-modal-last-step-description`)
                }
            ]
        }
    },
    computed: {
        ...mapGetters({
            notifications: GUser.GET_NOTIFICATIONS,
            userData : GUser.GET_USER_DATA
        })
    },
    methods: {
        notificationTitle(notification) {
            let title = '';

            switch (notification.type) {
                case 1:
                    title = 'New Bid';
                    break;
                case 2:
                    title = 'New Offer';
                    break;
                case 3:
                    title = (notification.isGiftDelivery ? 'Wine Gifts available for delivery' : 'New Collection');
                    break;
                case 4:
                    title = 'Market Match';
                    break;
                case 5:
                    title = 'Promotion';
                    break;
                case 7:
                    title = '⭐ New En Primeur Release 2023! ⭐';
                    break;
                case 9:
                    title = 'New Release';
                    break;
                default:
                    title = 'Your bid has been cancelled';
                    break;
            }
            return title;
        },
        formatDate(date) {
            return moment(date).locale(this.$i18n.locale).format('DD MMMM YYYY');
        },
        colorImage(id) {
            let imgUrl = null;
            switch (id) {
                case 1:
                    imgUrl = require('../assets/notifications/bids.png');
                    break;
                case 2:
                    imgUrl = require('../assets/notifications/offers.png');
                    break;
                case 4:
                    imgUrl = require('../assets/notifications/check.png');
                    break;
                default:
                    imgUrl = require('../assets/notifications/promotions.png');
                    break;
            }
            return imgUrl;
        },
        notificationSurveyAction() {
            this.surveyModal = true
        },
        closeSurveyModal() {
            let answers = {};
            answers.expoToken = this.userData.id;
            answers.surveyId = 2;
            answers.questions = [];
            answers.questions.push({
                "questionId": 5,
                "answerId": this.surveySlides[1].status
            });
            answers.questions.push({
                "questionId": 6,
                "answerId": this.surveySlides[2].status
            });
            answers.questions.push({
                "questionId": 7,
                "answerId": this.surveySlides[3].status
            });
            answers.questions.push({
                "questionId": 8,
                "answerId": this.surveySlides[4].status
            });
            // answers.isOnboardingSkipped = false;
            this.$store.dispatch(AUser.SET_SURVEY, answers);
            this.surveyModal = false
        },
        surveyNextStep() {
            this.surveyModalStep++
        },
        surveyPrevStep() {
            this.surveyModalStep--
        },
        notificationAction(item) {
            if (item.type === 3) {
                if (item.isGiftDelivery) {
                    this.$router.push(this.localePath({ path: '/christmas-gifts'}));
                } else {
                    this.$store.dispatch(AOrders.GET_COLLECTION_DETAILS, {
                        id: item.collectionId,
                        lang: this.$i18n.locale
                    }).then(() => {
                        this.$store.dispatch(AUser.GET_USER_COMMISSION);
                        this.$store.dispatch(AUser.GET_ADDRESSES);
                        this.$router.push(this.localePath({ path: `/collection-details/${item.collectionId}`}));
                    })
                }
            } else if (item.type === 5) {
                this.$router.push(this.localePath({ path: '/home/collections/'}));
            } else {
                this.$store.dispatch(AWines.SELECT_WINE_ID, {
                    wineId: item.wineId,
                    caseSize: item.caseSizeId,
                    languageId: this.$i18n.locale
                });
                this.$store.dispatch(AWines.GET_WINE_DETAILS).then(() => {
                    this.$router.push(this.localePath({ path: '/wine-details/' + item.wineId + '/' + item.caseSizeId + '/' + item.displayWineName.toLowerCase().split(' ').join('-')}));
                });
            }
        },
        delNotification(id) {
            let idArr = []
            idArr.push(id)

            this.$store.dispatch(AUser.DELETE_NOTIFICATION, {
                notificationIds: idArr,
                shouldDeleteAll: false
            }).then(() => {
                this.$store.dispatch(AUser.GET_NOTIFICATIONS)
            })
        }
    },
    created() {
        this.$store.dispatch(AUser.GET_NOTIFICATIONS)
    }
}
</script>

<style scoped>
.survey-modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    border-radius: 16px;
    background-color: var(--white) !important;
}

.survey-modal .survey-modal__body {
    padding-top: 64px;
    padding-bottom: 32px;
}

.survey-modal .survey-modal__body label {
    max-width: 464px;
    width: 100%;
    height: 56px;
    display: flex;
    align-items: center;
    margin: 0 auto;
    background: #F5F5F5;
    border-radius: 8px;
    text-align: left;
    padding: 0 15px;
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    color: rgba(0, 0, 0, 0.88);
}

.survey-modal .survey-modal__body label + label {
    margin-top: 16px;
}

.survey-modal .survey-modal__body label input {
    width: 20px;
    height: 20px;
    margin-right: 10px;
}

.survey-modal .survey-modal__body .v-card__title {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    justify-content: center;
    align-items: center;
    color: rgba(0, 0, 0, 0.88);
    word-break: break-word;
}

.survey-modal .survey-modal__body .v-card__text {
    color: rgba(0, 0, 0, 0.64);
}

.survey-modal .close-modal {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
}

.survey-modal .v-card__actions {
    width: 100%;
    padding: 0;
    margin-top: 30px;
    margin-bottom: 25px;
    justify-content: center;
}

.survey-modal .v-card__actions.space-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 30px auto 25px;
    max-width: 464px;
}

.survey-modal .v-card__actions .btn-primary {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
    text-transform: uppercase;
}

.survey-modal .v-card__actions .btn-survey-proceed {
    background: var(--blue);
    border-color: var(--blue);
    color: var(--white);
}

.survey-modal .v-card__actions .btn-survey-outline {
    background: var(--white);
    border-color: var(--blue);
    color: var(--blue);
}

.del-notification {
    position: absolute;
    top: 3px;
    right: 20px;
    width: 20px;
    height: 20px;
    text-align: center;
    z-index: 2;
    font-size: 24px;
}

.del-notification:hover {
    cursor: pointer;
}

.how-container {
    background: #ffffff;
}

.container {
    max-width: 784px;
    padding: 0;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
}

.inner-page-title {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    padding-top: 127px;
    padding-bottom: 87px;
    text-align: center;
    font-size: 49px;
    line-height: 49px;
    font-weight: 400;
    z-index: 2;
    position: relative;
    color: #303030;
}

.no-text {
    text-align: center;
    margin: 100px 0;
}

.list-item {
    min-height: 72px;
    padding: 7px 11px;
    position: relative;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.list-item:hover {
    cursor: pointer;
    background-color: #fbfbfb;
}

.list-item.survey {
    background: rgba(236, 246, 254, 1);
}

.list-item.survey:hover {
    background: rgba(236, 246, 254, 1);
}

.notification-title {
    padding-left: 48px;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
}

.notification-text {
    padding-left: 48px;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 14px;
    line-height: 12px;
    font-weight: 400;
    opacity: 0.5;
    margin-top: 4px;
    margin-bottom: 4px;
}

.notification-date {
    padding-left: 48px;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 12px;
    line-height: 14px;
    font-weight: 400;
}

.notification-image {
    width: 34px;
    height: 34px;
    position: absolute;
    top: 10px;
    left: 11px;
}

.container-margin {
    margin-bottom: 50px;
}

.settings {
    background: url('../assets/notifications/settings.png') no-repeat right;
    padding-right: 25px;
    color: #000000;
    text-decoration: none;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 14px;
    line-height: 17px;
    float: right;
    position: relative;
    top: -20px;
    z-index: 3;
}

.settings:hover {
    cursor: pointer;
    text-decoration: underline;
}

@media (max-width: 767px) {
    .inner-page-title {
        padding-top: 100px;
        font-size: 25px;
        line-height: 30px;
        padding-bottom: 50px;
    }

    .settings {
        top: -30px;
        left: 0;
        right: 0;
        margin: 0 auto;
        float: none;
        display: block;
        width: 85px;
    }
}
</style>
